import React from "react";
import { motion } from "framer-motion";
import { commitmentContent } from "./homeContent";
import "./HomeCommitment.css";

const HomeCommitment = () => (
  <section
    className="home-commitment py-14 lg:py-20"
    aria-labelledby="home-commitment-heading"
  >
    <div className="brand-col">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="home-commitment__card mx-auto max-w-3xl px-6 py-9 text-center sm:px-10 lg:px-14"
      >
        {/* decorative: the heading below it carries the meaning */}
        <span className="home-commitment__art" aria-hidden="true">
          <img
            className="home-commitment__img"
            src="/assets/cta/our-commitment-logo.webp"
            alt=""
            loading="lazy"
          />
        </span>
        <h2
          id="home-commitment-heading"
          className="mt-4 text-2xl md:text-3xl font-extrabold tracking-tight text-[var(--brand-primary)]"
        >
          {commitmentContent.title}
        </h2>
        <div className="home-commitment__rule mx-auto mt-3" />
        <h3 className="mt-3 text-lg md:text-xl font-bold text-gray-900">
          {commitmentContent.subtitle}
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-gray-600">
          {commitmentContent.paragraph}
        </p>
      </motion.div>
    </div>
  </section>
);

export default HomeCommitment;
